import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';

import SplitLayout from '../../layouts/SplitLayout/index';
import PageLayout from '../../layouts/PageLayout/index';
import FilteringPanel from './containers/FilteringPanel';
import PerDiemReportView from './containers/PerDiemReportView';

import { routerProps } from '../../propTypes';
import {
  getDepartment,
  getDepartmentId, getDistrict,
  getDistrictId, getEndDateApiFormat, getEndDateInputFormat, getStartDateApiFormat,
} from './selectors';
import { setDepartment, setDistrict, setEndDate } from './actions';


const propTypes = exact({
  endDateApi: PropTypes.string,
  startDateApi: PropTypes.string,
  districtId: PropTypes.number,
  departmentId: PropTypes.number,
  district: PropTypes.object,
  department: PropTypes.object,

  ...routerProps,
});

const PerDiemReport = (props) => {
  const {
    districtId,
    endDateApi,
    startDateApi,
    endDateInput,
    departmentId,
    district,
    department,
  } = props;

  return (
    <PageLayout
      title="Per Diem Summary"
      render={() => {
        return (
          <SplitLayout
            leftSize={2}
            leftRender={() => {
              return (
                <FilteringPanel
                  initialValues={{
                    endDate: endDateInput,
                    district,
                    department,
                  }}
                />
              );
            }}
            rightSize={10}
            rightRender={() => {
              return (
                <PerDiemReportView
                  startDate={startDateApi}
                  endDate={endDateApi}
                  districtId={districtId}
                  departmentId={departmentId}
                />
              );
            }}
          />
        );
      }}
    />
  );
};

PerDiemReport.propTypes = propTypes;

const mapStateToProps = (state) => {
  return {
    endDateApi: getEndDateApiFormat(state),
    endDateInput: getEndDateInputFormat(state),
    district: getDistrict(state),
    department: getDepartment(state),
    districtId: getDistrictId(state),
    departmentId: getDepartmentId(state),
    startDateApi: getStartDateApiFormat(state),
  };
};

const mapDispatchToProps = {
  setEndDateAction: setEndDate,
  setDepartmentAction: setDepartment,
  setDistrictAction: setDistrict,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const withInitPage = lifecycle({
  componentWillMount() {
    const { setEndDateAction, setDepartmentAction, setDistrictAction } = this.props;
    const currentDate = new Date();
    setEndDateAction(currentDate);

    setDepartmentAction(null);
    setDistrictAction(null);
  },
});

const enhance = compose(
  withRedux,
  withInitPage,
);

export default enhance(PerDiemReport);
